import type { FaqListDto } from '@nomiss/sdk';
import {
  ApiRequestError,
  executeSdkRawRequest,
} from './api-request.util';
import { faqsApi } from './sdk-client';

export type FaqItem = {
  id: string;
  slug: string;
  question: string;
  answer: string;
  category: string | null;
};

export type FaqListResponse = {
  items: FaqItem[];
  language: string;
};

export class FaqsError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'FaqsError');
  }
}

export async function getFaqs(
  lang?: string,
  category?: string,
): Promise<FaqListResponse> {
  const data = await executeSdkRawRequest<FaqListDto>({
    request: () =>
      faqsApi.faqsControllerListV1Raw({
        lang,
        category,
      }),
    fallback: 'Failed to load FAQs',
    ErrorClass: FaqsError,
  });

  return {
    language: data.language,
    items: (data.items ?? []).map(item => ({
      id: item.id,
      slug: item.slug,
      question: item.question,
      answer: item.answer,
      category:
        typeof item.category === 'string'
          ? item.category
          : item.category === null
            ? null
            : null,
    })),
  };
}
